import HighlightNeedOfferList from './HighlightNeedOfferList.jsx';

export {
  HighlightNeedOfferList
}


// WEBPACK FOOTER //
// ./components/home/sub-view/HighlightNeedOffer/index.js